import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.image.fields.id'),
  },
  {
    name: 'image',
    label: i18n('entities.image.fields.image'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'name',
    label: i18n('entities.image.fields.name'),
  },
  {
    name: 'info',
    label: i18n('entities.image.fields.info'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.image.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.image.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
